<script setup lang="ts">
import { gwtBridge } from '@/GWTBridge';
import { useDarkModeStore } from '@/stores/darkMode.store';
import { onMounted, useTemplateRef, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps<{
  src: string
}>()

const loadScreen = (url: string) => {
    gwtBridge.then((bridge) => {
        bridge.loadScreen(url);
    })
}

const RM4Screen = useTemplateRef("RM4Screen");
const router = useRouter();

watch(() => props.src, (newSrc) => {
    if (RM4Screen.value && RM4Screen.value.contentWindow && newSrc !== RM4Screen.value.contentWindow.location.pathname+RM4Screen.value.contentWindow.location.search) {
        RM4Screen.value.src = newSrc;
    }
});


router.beforeEach((to, from) => {
if (to.path.startsWith('/rm4') && to.fullPath === from.fullPath) {
    // If navigating to the same path under /rm4, force a reload
    const iframe = document.getElementById('RM4-iframe');
    if (iframe && RM4Screen.value) {
        RM4Screen.value.src = to.fullPath.replace(/^\/rm4/, '/RM4');
    }
  }
});

const BSvueHandleMessage = (e: MessageEvent) => {
    if (e.origin !== window.location.origin) return; // security check to verify that we receive event from trusted source
    if (typeof e.data !== "string") return; // This can't be meant for us since data is passed in the wrong format
    const returnedPair = e.data.split('|');
    if (returnedPair.length < 2) {
        return;
    }
    if (returnedPair[0] === 'newLoc') {
        history.replaceState(null, '', returnedPair[1]);
    }
};

const darkModeStore = useDarkModeStore();


onMounted(() => {
    if (RM4Screen.value) {
        RM4Screen.value.src = props.src;
    }
    RM4Screen.value?.addEventListener('load', () => {
        const location = RM4Screen.value?.contentWindow?.location
        const path = location?.href.replace(location?.origin, '').replace(/^\/RM4/, '/rm4');
        if(typeof path === 'string') {
            router.push(path);
            loadScreen(path.substring(1))
        }
        const iframeTitle = RM4Screen.value?.contentDocument?.title;
        if (iframeTitle) {
            document.title = iframeTitle;
        }
        watch(darkModeStore, (value) => {
          RM4Screen.value?.contentDocument?.documentElement.classList.toggle("bs-dark", value.isDarkMode)
        }, { immediate: true })
    });
    window.addEventListener("message", BSvueHandleMessage, false);
})

</script>

<template>
  <iframe ref="RM4Screen" id="RM4-iframe" style="width: 100%; height: 100%; border: none;"></iframe>
</template>